import { copyTextToClipboard } from "@/modules/clipboard/copyTextToClipboard";
import { toastModule } from "@/modules/toast";

export const copyUrlToClipboard = async ({ url }: { url: string }) => {
  await copyTextToClipboard({
    text: url,
  });
  toastModule.triggerToast({ content: "Link copied to clipboard" });
};
